import { render, staticRenderFns } from "./EditFeature.vue?vue&type=template&id=fae8a52a"
import script from "./EditFeature.js?vue&type=script&lang=js&external"
export * from "./EditFeature.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports